<template>
  <div class="container">
    <div class="news-top">
      <img src="https://cdnvue.gymcity.com.cn/uploads/out-show-top" alt />
      <div class="top-date">
        {{ transDate(outline.s_date, '.') }}—{{
          transDate(outline.e_date, '.')
        }}
      </div>
    </div>
    <div class="news-panel">
      <div class="panel-info">
        <img :src="outline.image" alt />
        <div class="name">{{ outline.u_name }}</div>
        <div class="desc">
          <div class="d-title">编写教练</div>
          <div class="d-text">{{ outline.c_name }}</div>
        </div>
        <div class="desc">
          <div class="d-title">课时数</div>
          <div class="d-text">{{ outline.total_class }}</div>
        </div>
      </div>
      <div class="panel-line"></div>
      <div class="panel-item">
        <div class="i-left">
          <i class="iconfont icon-zhouqi"></i>
        </div>
        <div class="i-desc">
          <div class="d-title">训练周期</div>
          <div class="d-text">
            {{ transDate(outline.s_date, '.') }}—{{
              transDate(outline.e_date.slice(-5), '.')
            }}
            <span>{{ status[outline.is_use] }}</span>
          </div>
        </div>
      </div>
      <div class="panel-item">
        <div class="i-left">
          <i class="iconfont icon-mubiao-3"></i>
        </div>
        <div class="i-desc">
          <div class="d-title">总体训练目标</div>
          <div class="d-text d-text-2">
            {{ $decodeURIComponent(outline.final_goals) }}
          </div>
        </div>
      </div>
      <div class="panel-coach">
        <div class="co-top">
          <img :src="outline.coach_image" alt />
          <div class="c-name">{{ outline.c_name }}</div>
          <div class="c-position">专属训练规划师</div>
        </div>
        <div class="co-say">
          <div class="say-item" v-html="outline.coach_summary"></div>
        </div>
      </div>
    </div>
    <div class="arr-item">
      <div class="i-title">
        <img
          src="https://cdnvue.gymcity.com.cn/uploads/out-icon-mb"
          class="icon"
          alt
        />
        <span>周期目标</span>
      </div>
      <div class="i-ul">
        <div
          class="i-li"
          v-for="(item, index) in outline.train_goals"
          :key="index"
        >
          <span class="out-dot"></span>
          <span class="li-text" v-html="item"></span>
        </div>
      </div>
    </div>
    <div class="arr-item">
      <div class="i-title">
        <img
          src="https://cdnvue.gymcity.com.cn/uploads/out-icon-ff"
          class="icon"
          alt
        />
        <span>训练方法</span>
      </div>
      <div class="i-ul">
        <div
          class="i-li"
          v-for="(item, index) in outline.train_method"
          :key="index"
        >
          <span class="out-dot"></span>
          <span class="li-text" v-html="item"></span>
        </div>

        <div class="tip-text">
          训练大纲仅作参考指导，具体训练计划实施将以会员实际情况为准。
        </div>
      </div>
    </div>
    <div class="arr-item">
      <div class="i-title">
        <img
          src="https://cdnvue.gymcity.com.cn/uploads/out-icon-ff"
          class="icon"
          alt
        />
        <span>训练模式</span>
      </div>
      <div class="i-ul">
        <div
          class="i-li"
          v-for="(item, index) in outline.train_model"
          :key="index"
        >
          <span class="out-dot"></span>
          <span class="li-text">{{ $decodeURIComponent(item) }}</span>
        </div>
      </div>
    </div>
    <div class="arr-item">
      <div class="i-title">
        <img
          src="https://cdnvue.gymcity.com.cn/uploads/out-icon-ysjy"
          class="icon"
          alt
        />
        <span>饮食建议</span>
      </div>
      <div class="i-ul">
        <div
          class="i-li"
          v-for="(item, index) in outline.dietary_suggestions"
          :key="index"
        >
          <span class="out-dot"></span>
          <span class="li-text" v-html="item"></span>
        </div>
      </div>
    </div>
    <div class="arr-item">
      <div class="i-title">
        <img
          src="https://cdnvue.gymcity.com.cn/uploads/out-icon-hfjy"
          class="icon"
          alt
        />
        <span>恢复建议</span>
      </div>
      <div class="i-ul">
        <span class="i-last"></span>
        <div
          class="i-li"
          v-for="(item, index) in outline.recover_suggestions"
          :key="index"
        >
          <span class="out-dot"></span>
          <span class="li-text" v-html="item"> </span>
        </div>
      </div>
    </div>

    <img
      src="https://cdnvue.gymcity.com.cn/uploads/pub-caise-logo"
      class="cai-logo"
      alt
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: ['执行中', '已执行', '未执行'],
      trainIndex: 0,
      suggestionsIndex: 0,
      outline: {
        u_name: '',
        image: 'https://cdnvue.gymcity.com.cn/uploads/pub-red-logo',
        s_date: '',
        e_date: '',
        c_name: '',
        courses: 0,
        train_model: [], // 模式
        train_method: [],
        train_goals: [],
        train_level: '', // 周期
        recover_suggestions: [],
        id: '',
        dietary_suggestions: [],
        coach_summary: [],
        total_class: 0,
        uid: ''
      },
      imgUrl: '',
      showMask: false
    }
  },
  computed: {},
  methods: {
    /**
     * 日期格式转换
     */
    transDate(date, to) {
      return date.replace(/-/g, to)
    },
    $decodeURIComponent(src) {
      // 判断如果是经过encode编码的格式或包含%25的则decode不然则直接返回
      // console.log('====================================');
      // console.log('解码', src);
      // console.log('====================================');
      if (
        src &&
        (src.search(/%([a-zA-Z]|[0-9])([a-zA-Z]|[0-9])%/) !== -1 ||
          src.search('%25') !== -1)
      ) {
        src = decodeURIComponent(src)
      }
      return src
    },
    getOutline() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      this.$http
        .get(
          'plan/OutlineUp',
          { a: 'outlineDetail', id: this.$route.query.id, opt: 2 },
          true
        )
        .then((res) => {
          this.$toast.clear()
          if (res.data.code === 200) {
            this.outline.u_name = res.data.data.truename
            this.outline.uid = res.data.data.uid
            this.outline.image = res.data.data.image
            this.outline.c_name = res.data.data.c_name
            this.outline.total_class = res.data.data.total_class
            this.outline.s_date = res.data.data.s_date
            this.outline.e_date = res.data.data.e_date
            this.outline.is_use = res.data.data.is_use
            this.outline.coach_image = res.data.data.coach.c_image
            this.outline.final_goals = res.data.data.aim_text

            this.outline.train_model = res.data.data.result.find(
              (item) => item.position === 1
            )
              ? [
                  res.data.data.result.find((item) => item.position === 1)
                    .content
                ]
              : '--'

            this.outline.coach_summary = res.data.data.result.find(
              (item) => item.position === 7
            )
              ? res.data.data.result.find((item) => item.position === 7).content
              : ''

            // 周期目标
            const trainGoalsText1 = res.data.data.result.find(
              (item) => item.position === 2
            )
              ? res.data.data.result.find((item) => item.position === 2).content
              : ''

            const trainGoalsText2 = res.data.data.result.find(
              (item) => item.position === 8
            )
              ? res.data.data.result.find((item) => item.position === 8).content
              : ''

            this.outline.train_goals = [
              ...trainGoalsText1.split('<br>'),
              ...trainGoalsText2.split('<br>')
            ].filter((item) => item)

            // 训练方法
            const trainmethodText3 = res.data.data.result.find(
              (item) => item.position === 3
            )
              ? res.data.data.result.find((item) => item.position === 3).content
              : ''
            const trainmethodText4 = res.data.data.result.find(
              (item) => item.position === 4
            )
              ? res.data.data.result.find((item) => item.position === 4).content
              : ''
            this.outline.train_method = [
              ...trainmethodText3.split('<br>'),
              ...trainmethodText4.split('<br>')
            ]

            this.outline.dietary_suggestions = res.data.data.result.find(
              (item) => item.position === 5
            )
              ? res.data.data.result
                  .find((item) => item.position === 5)
                  .content.split('<br>')
              : []

            this.outline.recover_suggestions = res.data.data.result.find(
              (item) => item.position === 6
            )
              ? res.data.data.result
                  .find((item) => item.position === 6)
                  .content.split('<br>')
              : []
          }
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id.indexOf(':') > -1) {
      next({
        path: '/newoutlineshow',
        query: to.query
      })
    } else {
      next()
    }
  },
  created() {
    this.getOutline()
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.container {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  z-index: 14;
  text-align: left;
  // background: linear-gradient(to bottom, #f71385, #dc0050);
  background-color: #f7f7f7;
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 10vw;
  // IOS底部安全兼容
  padding-bottom: calc(10vw + constant(safe-area-inset-bottom)); //兼容 IOS<11.2
  padding-bottom: calc(10vw + env(safe-area-inset-bottom)); //兼容 IOS>11.2
  header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f5f5;
    padding: vw(4 * 2) vw(12 * 2);
    box-sizing: border-box;
    position: relative;
    i {
      font-weight: 900;
      font-size: vw(20 * 2);
      padding: vw(5 * 2) vw(30 * 2);
    }
    .title {
      // font-weight: bold;
      color: #dc0050;
      font-size: vw(14 * 2);
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .right {
      font-size: vw(15 * 2);
    }
  }

  .news-top {
    width: 100%;
    height: 56.5vw;
    background-color: #dc0050;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    z-index: -1;
    img {
      width: 100%;
    }
    .top-date {
      font-size: 2.7vw;
      color: #fff;
      font-weight: 600;
      position: relative;
      top: -6vw;
    }
    .top-date-yc {
      top: -14vw;
    }
  }
  .news-top-yc {
    background-color: #f59393;
  }
  .news-panel {
    width: 91.5vw;
    background-color: #fff;
    border-radius: 1.6vw;
    padding: 4.8vw 0;
    margin-top: 18.1vw;
    .panel-info {
      width: 100%;
      padding: 0 6vw;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      img {
        width: 10.7vw;
        height: 10.7vw;
        border-radius: 50%;
      }
      .name {
        margin-left: 3.2vw;
        flex: 1;
        font-size: 4.3vw;
        font-weight: 600;
        text-align: left;
      }
      .desc {
        text-align: center;
        .d-title {
          font-size: 3.2vw;
          color: rgba(0, 0, 0, 0.5);
        }
        .d-text {
          font-size: 3.5vw;
          font-weight: 600;
          margin-top: 0.5vw;
          word-break: break-all;
          text-align: center;
        }
      }
      .desc + .desc {
        margin-left: 6.5vw;
      }
    }
    .panel-line {
      width: 100%;
      height: 0.3vw;
      background-color: #f7f7f7;
      margin-top: 4.5vw;
      padding: 0 4.3vw;
      box-sizing: border-box;
    }
    .panel-item {
      width: 100%;
      padding: 0 5.6vw;
      box-sizing: border-box;
      margin-top: 4vw;
      display: flex;
      align-items: center;
      .i-left {
        width: 10.7vw;
        height: 10.7vw;
        background-color: #f7f7f7;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 6vw;
        color: rgba($color: #000000, $alpha: 0.7);
        margin-right: 4.3vw;
        .iconfont {
          font-size: 5.8vw;
        }
      }
      .i-desc {
        flex: 1;
        .d-title {
          font-size: 3.2vw;
          color: rgba(0, 0, 0, 0.5);
        }
        .d-text {
          font-size: 3.7vw;
          font-weight: 600;
          color: #000;
          margin-top: 0.5vw;
          word-break: break-all;
          text-align: justify;
          span {
            display: inline-block;
            font-size: 2.7vw;
            color: #fff;
            padding: 0 1.6vw;
            background-color: #dc0050;
            border-radius: 0.8vw;
            margin-left: 2vw;
          }
        }
        .d-text-2 {
          background-color: #fff997;
          // padding-right: 1vw;
          display: inline-block;
          // text-align: justify;
        }
        .d-text-yc {
          background-color: #ffe8da;
        }
      }
    }
    .panel-coach {
      width: 81.3vw;
      padding: 4vw 5.3vw;
      box-sizing: border-box;
      background-color: #ffffff;
      border-radius: 1.6vw;
      border: solid 0.3vw #f1f1f1;
      // margin-left: 6.7vw;
      margin: 0 auto;
      margin-top: 6.4vw;
      .co-top {
        display: flex;
        align-items: center;
        img {
          width: 6.4vw;
          height: 6.4vw;
          border-radius: 3.2vw;
          margin-right: 2.7vw;
        }
        .c-name {
          font-size: 3.7vw;
          margin-right: 2.7vw;
          font-weight: 600;
        }
        .c-position {
          font-size: 3.2vw;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .co-say {
        margin-top: 2.4vw;
        font-size: 3.5vw;
        line-height: 5.9vw;
        color: rgba(0, 0, 0, 0.7);
        text-align: left;
        text-align: justify;
      }
    }
  }
  .news-panel-yc {
    margin-top: 25.6vw;
  }
  .arr-item {
    width: 100%;
    box-sizing: border-box;
    padding-left: 4.5vw;
    padding-right: 4vw;
    margin-top: 5.3vw;
    .i-title {
      display: flex;
      align-items: center;
      .icon {
        // color: #fd6163;
        width: 5.3vw;
      }
      span {
        font-size: 4.3vw;
        font-weight: 450;
        margin-left: 3.2vw;
      }
    }
    .i-ul {
      width: 82.9vw;
      background-color: #ffffff;
      border-radius: 1.6vw;
      padding: 3.5vw 4.5vw;
      box-sizing: border-box;
      margin-left: 8.5vw;
      position: relative;
      margin-top: 2.9vw;
      .i-li {
        display: flex;
        align-items: center;
        .out-dot {
          width: 3.2vw;
          height: 3.2vw;
          background-color: #ffffff;
          border: solid 0.8vw #dc0050;
          box-sizing: border-box;
          border-radius: 50%;
        }
        .li-text {
          flex: 1;
          font-size: 3.7vw;
          margin-left: 4vw;
          color: rgba(0, 0, 0, 0.7);
          word-break: break-all;
          text-align: justify;
          line-height: vw(50);
          // letter-spacing: vw(4);
        }
      }
      .i-li + .i-li {
        margin-top: 5.3vw;
      }
      .tip-text {
        margin-top: 5.3vw;
        font-size: vw(24);
        line-height: vw(40);
        color: rgba(#000, 0.7);
      }
    }
    .i-ul::after {
      content: '';
      height: 100%;
      border-left: dashed 0.5vw #dddddd;
      position: absolute;
      top: 0;
      left: -6.1vw;
    }
    .i-ul::before {
      content: '';
      border-left: solid 1.35vw transparent;
      border-top: solid 1.9vw #d8d8d8;
      border-right: solid 1.35vw transparent;
      border-bottom: solid 1.9vw transparent;
      position: absolute;
      bottom: -2.2vw;
      left: -7.2vw;
      z-index: 1;
    }
    .i-last {
      width: 2.7vw;
      height: 2.7vw;
      border-radius: 50%;
      background-color: #d8d8d8;
      border: none;
      position: absolute;
      bottom: -0.2vw;
      left: -7.2vw;
      z-index: 2;
    }
  }
  .cai-logo {
    width: 32.3vw;
    margin-top: 8.5vw;
  }
  .f-btns {
    height: vw(80);
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-top: 8vw;
    position: fixed;
    bottom: 0;
    // IOS底部安全兼容
    bottom: calc(0.1px + constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    bottom: calc(0.1px + env(safe-area-inset-bottom)); //兼容 IOS>11.2
    z-index: 98;
    .btn-item {
      font-family: PingFang SC;
      font-size: 4vw;
      color: #dc0050;
      font-weight: 600;
      width: 44.5vw;
      height: 10.7vw;
      background-color: #ffffff;
      border-radius: 1.6vw;
      border: solid 0.3vw #dc0050;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn-item + .btn-item {
      margin-left: 2.4vw;
    }
    .footer-btn {
      background-color: #dc0050;
      color: #fff;
      z-index: 89;
    }
  }
  .btn-float {
    width: 100vw;
    position: fixed;
    bottom: 0;
    // IOS底部安全兼容
    bottom: calc(0.1px + constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    bottom: calc(0.1px + env(safe-area-inset-bottom)); //兼容 IOS>11.2
    left: 0;
    z-index: 98;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: 8vw;
    .f-right {
      display: flex;
      flex-direction: column;
      // align-items: center;
      text-align: left;
      img {
        width: 32.3vw;
        margin-top: 3.2vw;
      }
      .f-text {
        font-size: 3.2vw;
        color: #000;
        text-align: center;
      }
    }
    #qrCode-canvas,
    .mini-qr-img {
      width: 17.1vw !important;
      height: 17.1vw !important;
      margin-right: 3.7vw;
      // background-color: #f00;
    }
    .qr-logo {
      position: absolute;
      width: vw(30);
      height: vw(30);
      right: vw(53);
      top: vw(53);
    }
  }
  .share-img {
    width: 0;
    // min-height: 100vh !important;
    position: absolute;
    // transform: rotate(180deg);
    top: 0;
    left: 0;
    transition: all 1.5s;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .on-share-img {
    width: 100vw;
    transform: rotate(360deg);
    transition: all 1.5s;
  }
}
</style>
